class TrackingMenu extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll("[data-selector]");
    this.containers = this.querySelectorAll("[data-menu]");
    this.setupListeners();
  }

  setupListeners() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        this.buttons.forEach((button) => {
          button.classList.remove("active");
        });

        button.classList.add("active");
        this.toggleMenu(e.target);
      });
    });
  }

  toggleMenu(target) {
    const selector = target.dataset.selector;
    const menu = this.querySelector(`[data-menu="${selector}"]`);

    this.containers.forEach((container) => {
      container.classList.add("lg:hidden");
    });

    menu.classList.remove("lg:hidden");
  }
}

customElements.define("tracking-menu", TrackingMenu);
